<div class="collapsible-area" fxLayout="column" fxLayoutAlign="start stretch" #collapsibleBlockEl>
	<div class="collapsible-header" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
		<div fxFlex="1 1 auto" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
			<ng-container *ngIf="![null, undefined, ''].includes(data?.icon)">
				<mat-icon class="title-icon">
					{{data?.icon}}
				</mat-icon>
			</ng-container>
			<ng-container *ngIf="![null, undefined, ''].includes(data?.svgIcon)">
				<mat-icon [svgIcon]="data?.svgIcon" class="title-icon">
				</mat-icon>
			</ng-container>
			<div fxLayout="row" fxFlex="1 1 auto" fxLayoutAlign="space-between center" fxLayoutGap="10px"
				fxLayout.xs="row wrap" fxLayoutAlign.xs="start center" fxLayoutGap.xs="5px">
				<div class="info" fxFlex="1 1 auto" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="5px"
					fxLayoutAlign.xs="center start" fxLayoutGap="5px">
					<ng-container *ngIf="![null, undefined, ''].includes(data?.title)">
						<div class="collapse-title" [ngClass]="{'xs' : detectDevice?.resolutionState$?.value?.xs}">
							{{data?.title}}
						</div>
					</ng-container>
					<ng-container *ngIf="![null, undefined, ''].includes(data?.desc)">
						<div class="sub-text-1">
							{{data?.desc}}
						</div>
					</ng-container>
				</div>
				<div>
					<ng-content select="[header-insight]"></ng-content>
				</div>
			</div>
		</div>
		<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
			<ng-container *ngIf="toggle?.showToggle || !toggle.hasOwnProperty('showToggle')">
				<button mat-icon-button (click)="toggleBlock()">
					<mat-icon class="collapse-icon">
						{{isOpened ? (toggle?.closedIcon) ? toggle?.closedIcon : 'remove' : (toggle?.expandedIcon) ?
						toggle?.expandedIcon : 'add' }}
					</mat-icon>
				</button>
			</ng-container>
		</div>
	</div>
	<div [@accordionX]="collapsible" [@.disabled]="disableAnimation" fxLayout="column" fxLayoutAlign="start stretch"
		class="collapsible-block-content" #contentBlockEl>
		<ng-content></ng-content>
	</div>
</div>
